/**
 * Orthopaedic Examination Data Points
 * Category: Orthopaedic
 */

export const orthopaedicDataPoints = [
  // Anatomical Areas
  {
    id: 'anatomical_areas',
    label: 'Anatomical Areas',
    category: 'Orthopaedic',
    subcategory: 'Examination Areas',
    fieldType: 'multi',
    isActive: true,
    options: ['Spine', 'Shoulder', 'Elbow', 'Wrist', 'Hand', 'Fingers', 'Back', 'Hip', 'Knee', 'Ankle', 'Foot'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Select anatomical areas for examination'
    },
    code: '113014009', // SNOMED CT - Musculoskeletal examination
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Look - Walking
  {
    id: 'walking',
    label: 'Walking',
    category: 'Orthopaedic',
    subcategory: 'Look',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Assessment of walking ability'
    },
    code: '129006008', // SNOMED CT - Walking
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Look - Swelling
  {
    id: 'swelling',
    label: 'Swelling',
    category: 'Orthopaedic',
    subcategory: 'Look',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Visual assessment for swelling'
    },
    code: '65124004', // SNOMED CT - Swelling
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Look - Bruising
  {
    id: 'bruising',
    label: 'Bruising',
    category: 'Orthopaedic',
    subcategory: 'Look',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Visual assessment for bruising'
    },
    code: '423898005', // SNOMED CT - Bruising
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Feel
  {
    id: 'feel',
    label: 'Feel',
    category: 'Orthopaedic',
    subcategory: 'Feel',
    fieldType: 'multi',
    isActive: true,
    options: ['Tender', 'Crepitus'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Palpation findings'
    },
    code: '113011001', // SNOMED CT - Palpation
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Move
  {
    id: 'move',
    label: 'Move',
    category: 'Orthopaedic',
    subcategory: 'Move',
    fieldType: 'multi',
    isActive: true,
    options: ['Active', 'Passive'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Range of motion assessment'
    },
    code: '364564000', // SNOMED CT - Range of motion
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default orthopaedicDataPoints
